"use strict";
exports.__esModule = true;
exports.SvgSymbolStatusTypeSlider = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgSymbolStatusTypeSlider = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 32 32" }, props),
    react_1["default"].createElement("path", { fill: "silver", d: "M29.5 13.49a2.5 2.5 0 010 5l-5.9.01c.26-.79.4-1.63.4-2.5 0-.87-.14-1.71-.4-2.5 1.38 0 5.83-.01 5.9-.01z" }),
    react_1["default"].createElement("path", { fill: "#000001", d: "M24 16c0 4.42-3.58 8-8 8-3.54 0-6.54-2.3-7.6-5.48l-5.87-.01a2.5 2.5 0 010-5c.05 0 3.34 0 5.86.01A8.007 8.007 0 0116 8c4.42 0 8 3.58 8 8z" }),
    react_1["default"].createElement("circle", { fill: "#fff", cx: 16, cy: 16, r: 7 }))); };
//# sourceMappingURL=SymbolStatusTypeSlider.js.map